import { isSecureRuntimeForServiceWorker } from './firebaseClient';

const FCM_SW_URL = '/firebase-messaging-sw.js';
const FCM_SW_SCOPE = '/firebase-push-scope/';

let fcmSwRegistrationPromise = null;

export async function getFcmServiceWorkerRegistration() {
  if (
    typeof window === 'undefined'
    || !('serviceWorker' in navigator)
    || !isSecureRuntimeForServiceWorker()
  ) {
    return undefined;
  }

  if (!fcmSwRegistrationPromise) {
    fcmSwRegistrationPromise = navigator.serviceWorker
      .register(FCM_SW_URL, {
        scope: FCM_SW_SCOPE,
        updateViaCache: 'none',
      })
      .then(async (registration) => {
        try {
          await registration.update();
        } catch {
          // Ignore update check errors; registration itself is enough for getToken.
        }
        return registration;
      })
      .catch((error) => {
        fcmSwRegistrationPromise = null;
        throw error;
      });
  }

  return fcmSwRegistrationPromise;
}
